module.exports = __webpack_public_path__ + "img/yylsyct.ef31891b.jpg";